import { createBrowserRouter } from 'react-router-dom';
import { lazyWithRetry } from '@repo/error';
import { isApplicationMode } from '@repo/env-variables';

import type { AppRouteObject } from '@router/types';
import { createRoutes } from '@router/createRoutes';
import { registerRoutes } from '@router/routeRegistry';

const devRoutes: AppRouteObject[] = isApplicationMode('dev') ? (await import('@features/dev/routes')).devRoutes : [];

const HomePage = isApplicationMode('dev') ? lazyWithRetry(() => import('@shared/pages/HomePage')) : null;

export const createRouter = () => {
  const routes = createRoutes({ devRoutes, HomePage });
  registerRoutes(routes);
  return createBrowserRouter(routes);
};
